var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandicon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 25.9964C50.0013 31.14 48.5358 36.1686 45.7889 40.4459C43.0421 44.7233 39.1371 48.0574 34.568 50.0265C29.999 51.9955 24.971 52.5111 20.1202 51.508C15.2693 50.5048 10.8135 48.0281 7.31625 44.391C3.81903 40.7539 1.43754 36.1198 0.472995 31.0749C-0.491547 26.03 0.00419388 20.801 1.89751 16.0491C3.79084 11.2973 6.99668 7.23614 11.1096 4.37938C15.2224 1.52261 20.0576 -0.00143596 25.0034 1.01522e-06C31.6329 1.01522e-06 37.9908 2.7389 42.6786 7.61416C47.3663 12.4894 49.9999 19.1017 49.9999 25.9964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1601 31.0024V19.8715L30.2781 25.4297L22.1601 31.0024ZM39.2134 20.104C39.2134 18.9324 38.7659 17.8088 37.9693 16.9803C37.1727 16.1519 36.0923 15.6865 34.9658 15.6865H15.0342C13.9077 15.6865 12.8273 16.1519 12.0307 16.9803C11.2342 17.8088 10.7867 18.9324 10.7867 20.104V31.9251C10.7903 33.0942 11.2395 34.2141 12.0357 35.0394C12.8318 35.8647 13.9101 36.3281 15.0342 36.3281H34.9658C36.0923 36.3281 37.1727 35.8627 37.9693 35.0342C38.7659 34.2058 39.2134 33.0822 39.2134 31.9106V20.0749V20.104Z",
    fill: "url(#paint0_linear_148_14576)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_14576",
    x1: 10.7867,
    y1: 25.9964,
    x2: 39.2134,
    y2: 25.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D4390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076BAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandicon03);
export default __webpack_public_path__ + "static/media/brandicon03.dbf87bd6a685c6f1158af0d67c75b9ab.svg";
export { ForwardRef as ReactComponent };